import angular from 'angular';
import { ImportDatafileActions } from '@/hybrid/tools/importDatafile/importDatafile.actions';

// This is a function as opposed to a default import due to angular trying to load this module before the ES6 class
// for ImportDatafileActions is loaded by JS, which results in the injected actions being undefined. By making this
// a function, the ES6 class will be loaded by the time angular loads the module.
export default () =>
  angular.module('Sq.ImportDatafile', ['Sq.Investigate']).service('sqImportDatafileActions', ImportDatafileActions);
